import { useParams } from "react-router-dom";

import { PrintControl } from "../components/print/printControl";

export const PrintTimesheet = () => {
  const { id, mode } = useParams();

  return <PrintControl id={id} mode={mode} />;
};
